import React from 'react';
import styles from './classes.module.css';

function ClassCard({ classData, onClick, onDelete, canEdit }) {
  const initial = classData.name ? classData.name.charAt(0).toUpperCase() : 'K';

  return (
    <div className={styles.card} onClick={onClick}>
      <div className={styles.cardMedia}>
        {classData.image ? (
          <img src={classData.image} alt={classData.name} />
        ) : (
          <div className={styles.mediaPlaceholder}>
            <span>{initial}</span>
          </div>
        )}
        <span className={styles.cardChip}>Klass</span>
      </div>
      <div className={styles.cardBody}>
        <div>
          <p className={styles.cardLabel}>Klassnamn</p>
          <h3>{classData.name}</h3>
        </div>
        {canEdit && onDelete && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(classData.id || classData._id || classData.name);
            }}
            className={styles.removeButton}
          >
            Ta bort
          </button>
        )}
      </div>
    </div>
  );
}

export default ClassCard;
